export default __webpack_public_path__ + "static/media/sd-mbl-deepam.3ecd7e0c.png";